'use client';

import { c as _c } from "react/compiler-runtime";
import { useAccommodationMutation } from '@feat/feat-accommodation/booking';
import { useSelectedRoomRate } from '@feat/feat-room-picker/store';
import { useUrlState } from '@feat/feat-url-state/use-url-state';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
import { useAppAvailableRooms } from '../_hooks/use-app-available-rooms';
import { getAccommodationAvailableRoomsInput } from '../_lib/accommodation-detail-query';
import { useAppAccommodationBookingBoxContext } from './app-accommodation-booking-box-provider';
import { AppAccommodationRoomRatesModal } from './app-accommodation-room-rates-modal';
type AppAccommodationRatesContainerProps = {
  accommodation: AccommodationFragment;
};
export function AppAccommodationRatesContainer(t0) {
  const $ = _c(18);
  const {
    accommodation
  } = t0;
  const {
    showRoomRatesModal,
    setShowRoomRatesModal
  } = useAppAccommodationBookingBoxContext();
  const {
    urlState
  } = useUrlState();
  const {
    rate
  } = useSelectedRoomRate();
  const {
    addAccommodation
  } = useAccommodationMutation(accommodation.id);
  let t1;
  if ($[0] !== accommodation.id || $[1] !== urlState) {
    t1 = getAccommodationAvailableRoomsInput({
      accommodationId: accommodation.id,
      urlState
    });
    $[0] = accommodation.id;
    $[1] = urlState;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: t2
  } = useAppAvailableRooms(t1);
  let t3;
  if ($[3] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const rooms = t3;
  const room = rooms[0];
  if (!room) {
    return null;
  }
  let t4;
  if ($[5] !== accommodation || $[6] !== addAccommodation || $[7] !== rate?.id || $[8] !== room || $[9] !== setShowRoomRatesModal) {
    t4 = async () => {
      const added = await addAccommodation({
        accommodation,
        rateId: rate?.id,
        room
      });
      if (added) {
        setShowRoomRatesModal(false);
      }
    };
    $[5] = accommodation;
    $[6] = addAccommodation;
    $[7] = rate?.id;
    $[8] = room;
    $[9] = setShowRoomRatesModal;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const onRateSelect = t4;
  let t5;
  if ($[11] !== setShowRoomRatesModal) {
    t5 = () => setShowRoomRatesModal(false);
    $[11] = setShowRoomRatesModal;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onRateSelect || $[14] !== room || $[15] !== showRoomRatesModal || $[16] !== t5) {
    t6 = <AppAccommodationRoomRatesModal room={room} isOpen={showRoomRatesModal} onSelect={onRateSelect} onClose={t5} />;
    $[13] = onRateSelect;
    $[14] = room;
    $[15] = showRoomRatesModal;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}